import { render, staticRenderFns } from "./DropdownModeratorSelector.vue?vue&type=template&id=5cd05398&scoped=true&"
import script from "./DropdownModeratorSelector.vue?vue&type=script&lang=js&"
export * from "./DropdownModeratorSelector.vue?vue&type=script&lang=js&"
import style0 from "./DropdownModeratorSelector.vue?vue&type=style&index=0&id=5cd05398&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd05398",
  null
  
)

export default component.exports